
<p-inc-todo-card
    :item = "item"
>
    <template v-slot:tag>
        <div class="lgs-state" :class="tagColor" v-if="item.lgsState">
            LGS
        </div>
    </template>
    <template v-slot:comment>
        <div class="v-flex">
            <div class="card-subtitle">
                {{ format (item.siteDownBegin) }}
            </div>
            <v-spacer/>
            <div class="card-subtitle" :class="textColor()" v-if="item.siteDownBegin">
                {{ delay }} Tage
            </div>
            <div class="card-subtitle error--text" v-if="!item.siteDownBegin">
                Beginn des Stillstandes fehlt
            </div>
        </div>
    </template>
</p-inc-todo-card>
